import React, { ReactNode } from 'react';
import ErrorBoundary from '@/components/shared/ErrorBoundary';

interface SafeSEOComponentProps {
  children: ReactNode;
  componentName: string;
}

/**
 * Wrapper component for SEO components that ensures they fail silently
 * SEO components should never crash the page as they're not visible to users
 */
const SafeSEOComponent: React.FC<SafeSEOComponentProps> = ({ 
  children, 
  componentName 
}) => {
  return (
    <ErrorBoundary
      fallback={
        process.env.NODE_ENV === 'development' ? (
          <div className="fixed bottom-4 right-4 bg-red-50 border border-red-200 rounded p-2 text-xs text-red-600 max-w-xs z-50 shadow-lg">
            <strong>SEO Component Error:</strong> '{componentName}' failed to load
          </div>
        ) : null
      }
    >
      {children}
    </ErrorBoundary>
  );
};

export default SafeSEOComponent;
